import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './order-number.scss';

type Props = ComponentPropsWithRef<'div'> & {
    orderNumber: string;
};
export const OrderNumber = ({ orderNumber, className, ...props }: Props) => {
    return (
        <div className={cn('order-number', className)} data-value={orderNumber} {...props}>
            <span>{orderNumber}.</span>
        </div>
    );
};
